// extracted by mini-css-extract-plugin
export default {"roundIcon":"RoleSelector_roundIcon__jU8hL","loader":"RoleSelector_loader__568A3"};